import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDataAuth } from "../../../hooks/useDataAuth";
import { useNotification } from '../../../hooks/useNotification';
import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useForm } from '../../../hooks/useForm';
import { useLocation } from 'react-router-dom';
import { callApi } from '../../../services/api.service';
import { ensureArray } from '../../../utils/validateResponseApi';

export const useManageGroup = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const [isEdit, setisEdit] = useState(false);
    const [errorInputs, , , validForm] = useErrorInputs({});
    const [dataActions, setdataActions] = useState([]);
    const [companiesSelect, setcompaniesSelect] = useState([]);

    const [values, handleInputChange, handleDirectInputChange, setAllInfo, reset] = useForm({
        id_company: '',
        name: '',
        prefix: '',
        status: '',
        status_step: '',
        path: '',
        cost_center: '',
        access: []
    });

    const validateForm = () => {
        const requiredFields = ["id_company", "name"];
        return validForm(requiredFields, values);
    };

    const getActions = async () => {
        try {
            const response = await callApi('user_action_select', 'SELECT_ACTIONS_FOR_GROUP', {}, userSession.token);
            if (response.status === 200) {
                console.log('response.getActions ', response.data);
                setdataActions(ensureArray(response.data));
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getCompanySelect = async () => {
        try {
            const response = await callApi('group_select', 'SELECT_COMPANYS_FOR_SELECT_GROUP', {}, userSession.token);
            if (response.status === 200) {
                setcompaniesSelect(ensureArray(response.data));
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getGroupById = async () => {
        if (location.state && location.state.config) {
            const { config } = location.state;
            console.log('CONSULTO REG EDITAR ', config);
            if (config.data?.id) {
                try {
                    setisEdit(true);
                    const id = config.data.id;
                    const response = await callApi('group_select', 'SELECT_BY_ID', { id_user_group: id }, userSession.token, { findOne: "true" });
                    if (response.status === 200) {
                        const val = {
                            ...response.data,
                            access: ensureArray(response.data?.access?.split(',').map(Number))
                        };
                        setAllInfo(val);
                    }
                } catch (err) {
                    console.error(err);
                }
            }
        }
    };

    useEffect(() => {
        const init = async () => {
            try {
                await Promise.all([
                    getGroupById(),
                    getCompanySelect(),
                    getActions(),
                ]);
            } catch (err) {
                console.error(err);
            }
        };
        init();
    }, []);

    const createOrUpdate = async (data, action) => {
        try {
            const response = await callApi('group_alter', action, data, userSession.token);
            if (response.status) {
                sendNotification({ variant: 'success', msg: t("messages.saveSuccess") });
            } else {
                sendNotification({ variant: 'error', msg: t("messages.saveError") });
            }
        } catch (error) {
            console.error(error);
        }
        setisEdit(false);
    };

    const save = (data) => createOrUpdate(data, isEdit ? 'UPDATE' : 'INSERT');

    return [{
        values,
        errorInputs,
        dataActions,
        companiesSelect,
        t,
        handleInputChange,
        handleDirectInputChange,
        setAllInfo,
        reset,
        validateForm,
        getActions,
        getCompanySelect,
        save
    }];
}
